import "./prasora-wsi-block.scss";
import m from "mithril";
import Swal from "sweetalert2";
import moment from "moment";
import svg from "../svg";
import dp from "../datepicker/datepicker";
import pf from "../pf";

export default () => {

    let UpdateWSinDS = null;

    function UpdateFixedDate(wi) {
        UpdateWorkstepInstance(wi, "SetFixedDate", wi.expectedon);
    }

    function UpdateCommitDate(wi) {
        UpdateWorkstepInstance(wi, "Reschedule", wi.committedon);
    }

    function UpdateRemarks(wi) {
        UpdateWorkstepInstance(wi, "Remarks", wi.remarks);
    }

    function UpdateNotRequired(wi) {
        UpdateWorkstepInstance(wi, "NotRequired");
    }

    function UpdateCompleted(wi) {
        UpdateWorkstepInstance(wi, "Complete");
    }

    async function UpdateWorkstepInstance(wi, actionname, value) {
        await pf.APIAction("UpdateWorkstepInstance", {
            id: wi.iid,
            actionname: actionname,
            wf: wi.wf,
            value: value
        }).then(r => {
            if (r)
                UpdateWSinDS(r);
        });
    }

    return {
        view: v => {

            UpdateWSinDS = v.attrs.UpdateWSinDS;
            let wi = v.attrs.wi;

            let allowedEditingCommittedOn = true;
            let cando = true;


            return m(".modal-wsi2", [
                m(".modal-wsi2-header", [
                    m(".modal-wsi2-title", wi.wsname),
                    m(".modal-cancel-button", {
                        onclick: () => {
                            if (v.attrs.onclose)
                                v.attrs.onclose();
                        }
                    }, [m(svg, {
                        name: "delete"
                    })])
                ]),
                m(".modal-wsi2-body", [
                    m(".modal-wsi-content", [
                        m(".modal-wsi2-wi-wrapper", [
                            m(".activity-title", `${wi.name} | Due for: ${wi.duefor || "Unassigned"}`),
                            m(".activity-details", [
                                m(".section-1", [
                                    m(".field-date-section", [
                                        m(".date-title", "Target Date"),
                                        m("span", moment(wi.expectedon).format('D MMM YYYY'))
                                    ]),
                                    wi.completed == "True" ?
                                    m(".field-date-section", [
                                        m(".date-title", "Completed On Date"),
                                        m("span", moment(wi.completedon).format('D MMM YYYY'))
                                    ]) :
                                    m(".field-date-section", [
                                        m(".date-title", "Committed Date"),
                                        allowedEditingCommittedOn ? m(dp, {
                                            class: ".date-value",
                                            options: {
                                                OnUpdateEvent: (val) => {
                                                    wi.committedon_old = wi.committedon;
                                                    wi.committedon = val;
                                                    UpdateCommitDate(wi);
                                                },
                                                defaultDate: wi.committedon || null
                                            }
                                        }) : m("span", wi.committedon ? moment(wi.committedon).format('D MMM YYYY') : "Not Set")
                                    ]),
                                    m(".field-date-section", [
                                        m(".date-title", "Expected Date"),
                                        m("span", moment(wi.possibleon).format('D MMM YYYY'))
                                    ])
                                ]),
                                m(".remarks-sections", [
                                    m(".sector-2-title", "Previous Remarks"),
                                    m("textarea.previous-remarks", wi.remarks),
                                ]),
                                m(".remarks-sections", [
                                    m(".sector-2-title", "Add New Remark"),
                                    m("textarea.new-remark", {
                                        value: wi.newremarks,
                                        oninput: (e) => {
                                            wi.newremarks = e.target.value;
                                        }
                                    }),
                                    wi.newremarks && m("button.add-remark-button", {
                                        type: "button",
                                        onclick: () => {
                                            wi.remarks_old = wi.remarks;
                                            if (wi.remarks)
                                                wi.remarks = `${wi.currentuser} (${moment().format('D MMM YYYY')}): ${wi.newremarks}
${wi.remarks}`;
                                            else
                                                wi.remarks = `${wi.currentuser} (${moment().format('D MMM YYYY')}): ${wi.newremarks}`;

                                            wi.newremarks = null;
                                            UpdateRemarks(wi);
                                        }
                                    }, "Add Remark")
                                ]),
                                m(".section-4", [
                                    (cando && wi.isdue) ? (wi.link ? m("a.icon-button.completion-button", {
                                            href: wi.link,
                                            target: "_blank"
                                        }, ["Complete This Activity"]) :
                                        m("button.icon-button.completion-button", {
                                            type: "button",
                                            onclick: () => {
                                                Swal.fire({
                                                    title: 'Are you sure?',
                                                    text: "False information is not acceptable",
                                                    type: 'info',
                                                    showCancelButton: true,
                                                    confirmButtonText: 'Yes, this activity is completed!'
                                                }).then((result) => {
                                                    if (result.value) {

                                                        UpdateWSinDS({
                                                            action: "complete",
                                                            wi: wi
                                                        });

                                                        UpdateCompleted(wi);
                                                    }
                                                })
                                            }
                                        }, ["Complete This Activity"])) : null,
                                ])
                            ])
                        ])
                    ])
                ])
            ]);
        }
    }
}